import PlayCircleOutlinedIcon from '@mui/icons-material/PlayCircleOutlined';
import { isEmpty } from 'lodash';
import { ScaleContainer } from 'src/components/scaleContainer/ScaleContainer';
import { CustomTooltip } from 'src/components/tooltip/CustomTooltip';
import { lang } from 'src/utils';

import { LayoutScreenBuilder } from '../layoutScreenBuilder';
import { LayoutScreens } from '../layoutScreens';
import { useScheduleComponentLayout } from './hooks/ScheduleComponentLayout.hook';
import {
  HeaderActionButton,
  LayoutScreensWrapper,
  ScheduleComponentLayoutWrapper,
  ScheduleHeaderRow,
  ScheduleNameHeader,
} from './ScheduleComponentLayout.styled';

interface IScheduleComponentLayoutHeader {
  showScheduleName: boolean;
  showPreviewButton: boolean;
  scheduleName?: string;
  isPreviewEnabled?: boolean;
  handlePreviewSchedule?: () => void;
}

const ScheduleComponentLayoutHeader = ({
  showScheduleName,
  showPreviewButton,
  scheduleName,
  isPreviewEnabled,
  handlePreviewSchedule,
}: IScheduleComponentLayoutHeader) => {
  return (
    <>
      {showScheduleName && (
        <CustomTooltip
          width={300}
          placement="bottom"
          title={scheduleName}
          overflowLineNumber={1}>
          <ScheduleNameHeader>{scheduleName}</ScheduleNameHeader>
        </CustomTooltip>
      )}
      {showPreviewButton && (
        <HeaderActionButton
          data-testid="preview-button"
          variant="outlined"
          disabled={!isPreviewEnabled}
          onClick={handlePreviewSchedule}
          startIcon={<PlayCircleOutlinedIcon />}>
          {lang.preview}
        </HeaderActionButton>
      )}
    </>
  );
};

export const ScheduleComponentLayout = () => {
  const {
    layout,
    scheduleName,
    customerState,
    activeAssemblyJourney,
    isCodConfirmationOpen,
    showLayoutScreenBuilder,
    screenIndex,
    gridSectionsWithoutDisclaimer,
    formMethods,
    screenSections,
    canDeleteCurrentSelectedSection,
    layerScreenSections,
    layerIndex,
    currentPositionGridLines,
    schedule,
    isPreviewEnabled,
    showSectionDetailDrawer,
    isAdditionalLocationGroups,
    onActiveSectionChange,
    onGridSectionsChange,
    setLayout,
    onUpdateScreenPredefinedSections,
    onUpdatePositionsGridLines,
    handlePreviewSchedule,
  } = useScheduleComponentLayout();
  const isEditScheduleFlow = isEmpty(schedule);

  return (
    <ScheduleComponentLayoutWrapper data-testid="schedule-component-layout">
      <ScheduleHeaderRow $showScheduleName={!isEditScheduleFlow}>
        <ScheduleComponentLayoutHeader
          showScheduleName={!isEditScheduleFlow}
          showPreviewButton={
            (!isEditScheduleFlow || !isAdditionalLocationGroups) &&
            !showLayoutScreenBuilder &&
            !showSectionDetailDrawer &&
            layerIndex !== -1
          }
          scheduleName={scheduleName}
          isPreviewEnabled={isPreviewEnabled}
          handlePreviewSchedule={handlePreviewSchedule}
        />
      </ScheduleHeaderRow>
      <ScaleContainer containerStyle={{ margin: 16 }}>
        <LayoutScreensWrapper>
          {!showLayoutScreenBuilder && (
            <LayoutScreens
              layout={layout}
              customerState={customerState}
              activeAssemblyJourney={activeAssemblyJourney}
              isCodConfirmationOpen={isCodConfirmationOpen}
              scale={1}
              layerScreenSections={layerScreenSections}
              currentPositionGridLines={currentPositionGridLines}
            />
          )}
          {showLayoutScreenBuilder && (
            <LayoutScreenBuilder
              layout={layout}
              screenIndex={screenIndex}
              scale={1}
              gridSections={gridSectionsWithoutDisclaimer}
              formMethods={formMethods}
              screenSections={screenSections}
              layerIndex={layerIndex}
              currentPositionGridLines={currentPositionGridLines}
              setGridSections={() => {}}
              onActiveSectionChange={onActiveSectionChange}
              onGridSectionsChange={onGridSectionsChange}
              setLayout={setLayout}
              canDeleteCurrentSelectedSection={canDeleteCurrentSelectedSection}
              onUpdateScreenPredefinedSections={
                onUpdateScreenPredefinedSections
              }
              onUpdatePositionsGridLines={onUpdatePositionsGridLines}
            />
          )}
        </LayoutScreensWrapper>
      </ScaleContainer>
    </ScheduleComponentLayoutWrapper>
  );
};
